import * as msal from "@azure/msal-browser";

import CleaningUserAuthenticator from "../authenticators/cleaningUserAuthenticator";

import CleaningManagementService from "./cleaningManagementService";

export default class AccessService {
  private readonly userAuthenticator: CleaningUserAuthenticator;

  private readonly cleaningManagementService: CleaningManagementService;

  public constructor() {
    this.userAuthenticator = new CleaningUserAuthenticator();
    this.cleaningManagementService = new CleaningManagementService();
  }

  public async ensureAccessAsync(): Promise<
    { user: msal.AccountInfo; isAuthenticated: boolean } | { user: null; isAuthenticated: boolean }
  > {
    const user = await this.userAuthenticator.authenticateUserAsync();
    if (!user) {
      return { user: null, isAuthenticated: false };
    }

    const hasAccess = await this.cleaningManagementService.ensureAccess();
    return { user, isAuthenticated: hasAccess };
  }
}
